/* eslint-disable */
var CryptoJS = require("crypto-js");
var url = require('url');

const localStorage = window.localStorage;

class ConfigD {

    /* Private */
    static ensureSlash(path, needsSlash) {
        var hasSlash = path.endsWith('/');

        if (hasSlash && !needsSlash) {
            return path.substr(path, path.length - 1);
        }
        else if (!hasSlash && needsSlash) {
            return path + '/';
        }
        else {
            return path;
        }
    }

    /* Private */
    static getUrlParts(url) {

        var a = document.createElement('a');
        a.href = url;

        return {
            href: a.href,
            host: a.host,
            hostname: a.hostname,
            port: a.port,
            pathname: a.pathname,
            protocol: a.protocol,
            hash: a.hash,
            search: a.search,
            urlBase: a.protocol + '//' + a.hostname + (a.port != '' ? ':' + a.port : '')
        };
    }

    /*
       Retorna o endereço base do webservice de acordo com a url. Pode variar porque é uma build para vários clientes
       no caso o que é alterado é o BASE (ver configuração no IIS, as pastas de usuário possuem um web.config herdado)
        Ex: http://app.ativa360.com.br/User/%projeto%/site/ServiceLayer/
        Ex: http://app.ativa360.com.br/User/BASE/ServiceLayer/
    */
    static getWSURL() {

        var urlDesenv = 'http://localhost:1376/ServiceLayer/';
        //var urlDesenv = 'http://192.168.1.5/VastiSebraeDesenv/ServiceLayer/';
        //var urlDesenv = 'http://app.ativa360.com.br/User/BASE/ServiceLayer/';

        //Verifica se esta em producao ou desenvolvimento (possui porta na url) (group1) é localhost (group2)
        var reIsLocal = new RegExp("(:\d\d\d)|(localhost)");

        if (reIsLocal.test(window.location.href))
        {
            return urlDesenv;
        }
        else
        {
            var ret = this.getUrlParts(window.location.href).urlBase + '/ServiceLayer/';
            return ret;
        }
    }

    static getDownloadArquivoURL(hash, nomeArquivo)
    {
        
        var urlDownload = this.getWSURL().replace('ServiceLayer', 'Consultar') + "download.aspx?hash=" + hash + "&nomeArquivo=" + nomeArquivo;
        return urlDownload;
    }

    /* Retorna o endereço base de acordo com a url:
        Ex: serverBase: /User/%projeto%/site/AppForm
        Ex: serverBase: /User/BASE/AppForm
    */
    static getServerBase() {
        
        //para testar local, tirar comentario abaixo
        //return '';
        //Verifica se esta em producao ou desenvolvimento (possui porta na url) (group1) é localhost (group2)
        var reIsLocal = new RegExp("(:\d\d\d)|(localhost)");

        if (reIsLocal.test(window.location.href)) {
            return '';
        }
        else {

            var url = this.getUrlParts(window.location.href).pathname.toLowerCase();

            var ret = url.substring(0, url.indexOf('appform') + 7);

            if (ret.substring(0, 1) != '/') ret = '/' + ret;
            //if (!ret.startsWith('/')) ret = '/' + ret;

            return ret;
        }
    }

    static getStore(chaveStore) {

        var ret = '';

        try {
            var obj = localStorage.getItem(chaveStore);

            if (obj !== null && obj !== '') {
                var bytes = CryptoJS.AES.decrypt(obj, '4QP4jpbCqBtC5XT');
                ret = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }
        }
        catch (err) {
        }

        return ret;
    }

    static setStore(chaveStore, objeto) {

        if (objeto !== null && objeto !== '') {
            var obj = CryptoJS.AES.encrypt(JSON.stringify(objeto), '4QP4jpbCqBtC5XT');
            localStorage.setItem(chaveStore, obj);
        }
        else {
            localStorage.setItem(chaveStore, '');
        }
    }

    static removeStore(chaveStore) {
        localStorage.removeItem(chaveStore);
    }

    static getCookie(chaveCookie) {
        var ret = '';

        try {
            var name = ConfigD.getServerBase().replace(/^\//, '').toLowerCase() + '_' + chaveCookie + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1);
                if (c.indexOf(name) === 0) {
                    var val = c.substring(name.length, c.length);
                    if (val !== null && val !== '') {
                        try {
                            ret = JSON.parse(val);
                        } catch (e) {
                            ret = val;
                        }
                    }
                    break;
                }
            }
        }
        catch (err) {
        }

        return ret;
    }

    static setCookie(chaveCookie, objeto, diasExpiracao) {
        try {
            var key = ConfigD.getServerBase().replace(/^\//, '').toLowerCase() + '_' + chaveCookie;
            var valor = '';
            if (objeto !== null && objeto !== '') {
                valor = typeof objeto === 'string' ? objeto : JSON.stringify(objeto);
            }

            var expires = '';
            if (typeof diasExpiracao === 'number' && diasExpiracao > 0) {
                var d = new Date();
                d.setTime(d.getTime() + (diasExpiracao * 24 * 60 * 60 * 1000));
                expires = ';expires=' + d.toUTCString();
            }

            var path = '/' //ConfigD.getServerBase().replace(/^\//, '');;
            document.cookie = key + '=' + encodeURIComponent(valor) + expires + ';path=' + path;
        }
        catch (err) {
        }
    }

    static removeCookie(chaveCookie) {
        try {
            var key = ConfigD.getServerBase().replace(/^\//, '').toLowerCase() + '_' + chaveCookie;
            var path = '/' //ConfigD.getServerBase().replace(/^\//, '');;
            document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=' + path;
        }
        catch (err) {
        }
    } 

}

export default ConfigD;


/** WEBPACK FOOTER **
 ** ./src/components/util/ConfigD.js
 **/